import deviceFallbackIcon from "@/assets/device-fallback.png";
import { MAX_GLOBAL_SEARCH_OPTIONS } from "@/constants";
import { MenuItem } from "@trimble/modus-cmx";
import { highlightMatch } from "@/components/app/Navigation/GlobalHeader/helper";
import type { DevicesOptionProps } from "@/components/Navigation/GlobalHeader/GlobalSearch/types";
import { ViewAllOption } from "../ViewAllOption/ViewAllOption";

export function DeviceOption({
  options,
  totalCount,
  searchTerm,
  onViewAll,
}: DevicesOptionProps) {
  const optionsToDisplay = options.slice(0, MAX_GLOBAL_SEARCH_OPTIONS);
  return (
    <>
      {optionsToDisplay.map((option) => (
        <MenuItem key={option.deviceId} value={option.deviceId}>
          <div slot="start-icon" className="option">
            <img
              src={option.iconUrl || deviceFallbackIcon}
              alt=""
              width={18}
              height={18}
              onError={(e) => {
                const el = e.currentTarget;
                if (el.dataset.fallbackApplied != null) return;
                el.dataset.fallbackApplied = "";
                el.src = deviceFallbackIcon;
              }}
            />
            <div className="option-details">
              <div className="option-device-primary-row">
                <span className="option-contract-number">
                  {highlightMatch(option.deviceName, searchTerm)}
                </span>
                {option.deviceSerialNumber &&
                option.deviceSerialNumber.length > 0 ? (
                  <span className="option-customer-name">
                    {highlightMatch(option.deviceSerialNumber, searchTerm)}
                  </span>
                ) : null}
              </div>
              {option.devicePartNumber && option.devicePartNumber.length > 0 ? (
                <span className="option-customer-name">
                  {highlightMatch(option.devicePartNumber, searchTerm)}
                </span>
              ) : null}
              {option.deviceReference && option.deviceReference.length > 0 ? (
                <span className="option-po-number">
                  {highlightMatch(option.deviceReference, searchTerm)}
                </span>
              ) : null}
            </div>
          </div>
        </MenuItem>
      ))}
      {totalCount > MAX_GLOBAL_SEARCH_OPTIONS && (
        <ViewAllOption
          totalCount={totalCount}
          onViewAll={onViewAll}
          searchCategory="devices"
        />
      )}
    </>
  );
}
